import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { useApi, useFetch, useMe, errMsg, fmtDay } from "../lib/api";
import { Btn, Card, PageHeader, PriorityBadge, ScorePill, StateBadge } from "../components/common";
import { ContactForm } from "./Contacts";

export default function CompanyDetail() {
  const { id } = useParams();
  const api = useApi();
  const { isAdmin } = useMe();
  const { data: c, reload } = useFetch(`/companies/${id}`);
  const [form, setForm] = useState({ website: "", notes: "" });
  useEffect(() => { if (c) setForm({ website: c.website || "", notes: c.notes || "" }); }, [c]);
  if (!c) return <div className="text-sm text-slate-500">Loading…</div>;
  const save = async () => { try { await api.put(`/companies/${id}`, form); toast.success("Saved"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div>
      <PageHeader title={c.name} subtitle={`${c.category} · ${(c.countries || []).join(", ")} · sources: ${(c.sources || []).join(", ")}`} />
      <div className="grid gap-6 lg:grid-cols-3">
        <Card title="Opportunities" className="lg:col-span-2" testid="company-opps">
          <table className="dm-table w-full"><thead><tr><th>Title</th><th>Priority</th><th className="text-right">Score</th><th>Status</th><th>Published</th></tr></thead>
            <tbody>{c.opportunities.map((o) => (
              <tr key={o.id}><td><Link className="text-blue-700 hover:underline" to={`/admin/opportunities/${o.id}`}>{o.title}</Link></td>
                <td><PriorityBadge p={o.priority} /></td><td className="text-right"><ScorePill score={o.score} /></td><td><StateBadge s={o.status} /></td><td className="text-xs">{fmtDay(o.published_at)}</td></tr>))}</tbody>
          </table>
        </Card>
        <Card title="Company notes" testid="company-notes">
          <label className="text-xs text-slate-500">Public website</label>
          <input data-testid="company-website-input" className="dm-input mb-3 w-full" value={form.website} disabled={!isAdmin} onChange={(e) => setForm({ ...form, website: e.target.value })} />
          <label className="text-xs text-slate-500">Notes</label>
          <textarea data-testid="company-notes-input" className="dm-input h-28 w-full py-2" value={form.notes} disabled={!isAdmin} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
          {isAdmin && <Btn className="mt-3" onClick={save} data-testid="company-save">Save</Btn>}
        </Card>
      </div>
      <Card title="Contacts (publicly listed business contacts only)" className="mt-6" testid="company-contacts">
        {c.contacts.map((x) => (
          <div key={x.id} className="mb-2 flex flex-wrap items-center gap-3 border-b border-slate-100 pb-2 text-sm">
            <span className="font-medium">{x.name || "(name not published)"}</span><span className="text-slate-500">{x.role}</span>
            <span className="font-mono text-xs">{x.email}</span><StateBadge s={`confidence_${x.confidence}`} />
            <a className="text-xs text-blue-700 hover:underline" href={x.source_url} target="_blank" rel="noreferrer">source</a>
          </div>))}
        {isAdmin && <ContactForm companyId={id} onSaved={reload} />}
      </Card>
    </div>
  );
}
